"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nativeSort = exports.nativeSortResultSchema = exports.nativeSortArgsSchema = exports.SortTypeSchema = exports.SortDirectionSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// Sort direction enum
exports.SortDirectionSchema = zod_1.z.enum(['asc', 'desc']);
// Sort type enum
exports.SortTypeSchema = zod_1.z.enum(['auto', 'string', 'number', 'date']);
// Native sort arguments schema
exports.nativeSortArgsSchema = zod_1.z.object({
    array: zod_1.z.array(zod_1.z.any()).describe('The array to sort'),
    sortBy: zod_1.z
        .union([zod_1.z.string(), zod_1.z.array(zod_1.z.string())])
        .describe('Field path(s) to sort by. Use dot notation for nested fields (e.g. "user.name"). Multiple fields for multi-level sorting.'),
    direction: zod_1.z
        .union([exports.SortDirectionSchema, zod_1.z.array(exports.SortDirectionSchema)])
        .default('asc')
        .describe('Sort direction(s). Single direction applies to all fields, or specify per field.'),
    sortType: exports.SortTypeSchema.default('auto').describe('How to interpret values for sorting. Auto detects type from first non-null value.'),
    preserveHeaderRow: zod_1.z
        .boolean()
        .default(true)
        .describe('For CSV data with header row, preserve header at index 0 and sort data rows only.'),
});
// Native sort result schema
exports.nativeSortResultSchema = zod_1.z.object({
    sortedArray: zod_1.z.array(zod_1.z.any()).describe('The sorted array'),
    metadata: zod_1.z.object({
        originalLength: zod_1.z.number().describe('Number of items in original array'),
        sortedLength: zod_1.z.number().describe('Number of items in sorted array'),
        sortFields: zod_1.z.array(zod_1.z.string()).describe('Fields used for sorting'),
        sortDirections: zod_1.z.array(exports.SortDirectionSchema).describe('Sort directions applied'),
        detectedTypes: zod_1.z
            .array(exports.SortTypeSchema)
            .describe('Detected or specified types for each sort field'),
        headerPreserved: zod_1.z.boolean().optional().describe('Whether CSV header row was preserved'),
        executedAt: zod_1.z.string().describe('Timestamp when sort was executed'),
    }),
});
// Tool metadata
exports.nativeSort = (0, common_1.createToolMetadata)({
    id: 'nativeSort',
    displayName: 'Sort Array',
    displayDescription: 'Sort arrays and CSV data by field values with flexible options',
    category: 'native',
    color: common_1.BRAND_COLORS.NATIVE,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.NATIVE),
    icon: 'target', // Using target icon to represent sorting/ordering
    argsSchema: exports.nativeSortArgsSchema,
}, exports.nativeSortResultSchema);
